<template>
  <product-section :product="product" />
</template>

<script>
import ProductSection from '~/sections/ProductSection'
// import Head from '~/mixins/Head'
export default {
  name: 'Page',
  transition: 'page',
  components: {
    ProductSection
  },
  // mixins: [Head],
  asyncData({ store, params }) {
    return store
      .dispatch('shop/getProductByHandle', params.slug)
      .then((response) => {
        return { product: response }
      })
  },
  mounted() {
    this.$root.$emit('scrollOnMount')
  }
}
</script>

<style lang="scss" scoped></style>
